import { useGetDeviceType } from "_common/hooks/global";
import BroadcasterTitle     from "_components/atoms/broadcastTitle";
import Divider              from "_components/atoms/divider";
import Render               from "_components/atoms/render";
import BroadcastChips       from "_components/molecules/broadcastChips";
import BroadcasterHeader    from "_components/molecules/broadcasterHeader";
import { STREAM_TIER }      from "_components/pages/proPage/constants";

import useStyles from "../styles";

import ActionButtonsList from "./actionsButtnosList";
import Ads               from "./ads";

const component = props => {
	const {
		broadcastData,
		sessionData,
		broadcastId,
		theatreModeToggle,
		isBlockedByStreamer,
		totalReactions,
		staticTotalComments,
		staticTotalReactions
	} = props;

	const commentsCount = sessionData?.totalComments ? sessionData?.totalComments : staticTotalComments;
	const likesCount    = ( totalReactions && ( totalReactions > staticTotalReactions ) ) ? totalReactions : staticTotalReactions;

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet";

	const { classes } = useStyles ( undefined, { name: "styles" } );

	let id, photo, name, isCeleb, isFollowing;

	if ( broadcastData && broadcastData.broadcaster && broadcastData.broadcaster.sportsFan ) {
		id          = broadcastData.broadcaster.sportsFan.id;
		photo       = broadcastData.broadcaster.sportsFan.photo;
		name        = broadcastData.broadcaster.sportsFan.name;
		isCeleb     = broadcastData.broadcaster.sportsFan.isCeleb;
		isFollowing = broadcastData.broadcaster.sportsFan.isFollowing;
	}

	if ( theatreModeToggle )
		return null;

	const description    = sessionData?.description || broadcastData?.description;
	const followersCount = broadcastData.broadcaster?.followerCount;

	return (
		<>
			<div className = { classes.streamDetailsContainer }>

				<Render condition = { broadcastData?.showAds ?? true }>
					<Ads />
				</Render>

				<BroadcasterTitle
					broadcastId       = { broadcastId }
					endTimeUTC        = { sessionData?.endTimeUTC }
					sessionData       = { sessionData?.sessionInfo || broadcastData?.sessionInfo }
					startedTimeUTC    = { broadcastData?.startTimeUTC }
					theatreModeToggle = { theatreModeToggle }
					totalComments     = { commentsCount }
					totalLikes        = { likesCount }
					totalViews        = { broadcastData?.endTimeUTC ? broadcastData?.views : 0 }
				/>

				<BroadcastChips
					game              = { broadcastData?.game }
					isLeaderBoardLive = { broadcastData?.isLeaderBoardLive }
					isProStream       = { broadcastData.streamTier?.toString () === STREAM_TIER.PRO_STREAM }
					localeKey         = { broadcastData?.localeKey }
					sessionDataId     = { broadcastData?.id }
					tags              = { broadcastData?.tags }
					title             = { broadcastData?.sessionInfo }
				/>

				{
					isMobileOrTablet ? (
						<ActionButtonsList
							isLeaderBoardLive = { broadcastData?.isLeaderBoardLive }
							isLiked           = { broadcastData?.isReacted }
							sessionId         = { broadcastId }
						/>
					) : null
				}

			</div>

			<Divider
				style = { {
					margin: "3px 0"
				} }
			/>

			<BroadcasterHeader
				description         = { description }
				followersCount      = { followersCount }
				id                  = { id }
				isBlockedByStreamer = { isBlockedByStreamer }
				isCeleb             = { isCeleb }
				isFollowingUser     = { isFollowing }
				name                = { name }
				photo               = { photo }
				theatreModeToggle   = { theatreModeToggle }
			/>

			<Divider
				style = { {
					margin: "3px 0"
				} }
			/>
		</>
	);
};

export default component;
